<template>
    <div class="center-page">
        <el-page-header style="margin-bottom: 20px;" @back="$router.back()"
                        :content="`${id?'编辑':'新增'}房源`"></el-page-header>
        <el-form :model="addForm" :rules="rules" label-position="right" label-width="150px" ref="forms">
            <el-form-item label="房源标题：" prop="title">
                <el-input style="width: 50%;" v-model="addForm.title" placeholder="地点+特色词"></el-input>
            </el-form-item>
            <el-form-item label="封面照片：" prop="cover">
                <el-upload
                        action=""
                        class="avatar-uploader"
                        :http-request="uploadCover"
                        :show-file-list="false">
                    <img v-if="addForm.cover" :src="`/api/v1/file/${addForm.cover}`" class="avatar" alt="">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="展示照片：" required>
                <transition-group tag="div" name="drag" class="img-content">
                    <img @dragstart="handlerStart(item,index)"
                         @dragend="handlerEnd(item,index)"
                         @dragenter="handlerEnter(item,index)"
                         @click="delImg(index)"
                         v-for="(item,index) in addForm.image"
                         :key="item"
                         class="img-content-item" :src="`/api/v1/file/${item}`" alt="">
                    <el-upload
                            action=""
                            key="upload"
                            :http-request="uploadImage"
                            class="avatar-uploader"
                            :show-file-list="false">
                        <i slot="trigger" class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                    </el-upload>
                </transition-group>
            </el-form-item>
            <el-form-item label="房源类型：" prop="house_type_id">
                <el-select v-model="addForm.house_type_id">
                    <el-option v-for="(item,index) in select.house" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="房间类型：" prop="room_type_id">
                <el-select v-model="addForm.room_type_id">
                    <el-option v-for="(item,index) in select.room" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="标准收费人数：" required>
                        <el-input-number style="margin-right: 10px;" v-model="addForm.people" :min="1"
                                         :step="1"></el-input-number>
                        人
                    </el-form-item>
                    <el-form-item label="独立卫生间个数：" required>
                        <el-input-number style="margin-right: 10px;" v-model="addForm.toilet['独立卫生间']" :min="0"
                                         :step="1"></el-input-number>
                        个
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="房间最多入住人数：" required>
                        <el-input-number style="margin-right: 10px;" v-model="addForm.max_people" :min="1"
                                         :step="1"></el-input-number>
                        人
                    </el-form-item>
                    <el-form-item label="公共卫生间个数：" required>
                        <el-input-number style="margin-right: 10px;" v-model="addForm.toilet['公共卫生间']" :min="0"
                                         :step="1"></el-input-number>
                        个
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="床的类型：" required>
                <div class="input-content">
                    <el-input style="width: 42%;"
                              class="mr-10 mb-10"
                              type="number"
                              :min="0"
                              v-for="(item,index) in addForm.bed_id"
                              v-model="item.number" :key="index">
                        <div style="width: 100px;" slot="prepend">{{item.name}}</div>
                        <template slot="append">张</template>
                    </el-input>
                </div>
            </el-form-item>
            <el-form-item label="配套设置（多选）：" prop="facility_id">
                <el-checkbox-group v-model="addForm.facility_id">
                    <el-checkbox v-for="(item,index) in select.facility" :key="index" :label="item.id">{{item.name}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="房源位置：" prop="area_id">
                <el-select v-model="addForm.area_id" filterable>
                    <el-option v-for="(item,index) in cityList" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
                <el-input style="width: 60%;" v-model="addForm.address" placeholder="请输入详细地址">
                    <el-button slot="append" @click="showMap=true;">地图选点</el-button>
                </el-input>
            </el-form-item>
            <el-form-item label="房源介绍：" prop="content">
                <el-input type="textarea"
                          v-model="addForm.content"
                          placeholder="请输入房源介绍"
                          :autosize="{ minRows: 8, maxRows: 16}"
                          maxlength="2500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="入住规则：">
                <el-input type="textarea"
                          v-model="addForm.check_in_rules"
                          placeholder="请输入入住规则"
                          :autosize="{ minRows: 4, maxRows: 8}"
                          maxlength="1000" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="退款规则：" prop="mark">
                <el-radio-group v-model="addForm.mark">
                    <el-radio class="mt-10" v-for="(item,index) in houseRules[0]" :key="index" :label="item.id">
                        {{item.content}}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="价格：" prop="price">
                <el-input style="width: 30%;" v-model="addForm.price" placeholder="请输入价格">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                    <template slot="append">/晚</template>
                </el-input>
            </el-form-item>
            <el-form-item label="7天折扣价：" prop="discount7">
                <el-input style="width: 30%;" v-model="addForm.discount7" placeholder="7天折扣价">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                    <template slot="append">/晚</template>
                </el-input>
            </el-form-item>
            <el-form-item label="30天折扣价：" prop="discount30">
                <el-input style="width: 30%;" v-model="addForm.discount30" placeholder="30天折扣价">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                    <template slot="append">/晚</template>
                </el-input>
            </el-form-item>
            <el-form-item label="押金：" prop="deposit">
                <el-input style="width: 30%;" v-model="addForm.deposit" placeholder="请输入押金">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                </el-input>
            </el-form-item>
            <el-form-item label="额外人员费用：" prop="capitation">
                <el-input style="width: 30%;" v-model="addForm.capitation" placeholder="额外人员费用">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                    <template slot="append">/晚</template>
                </el-input>
            </el-form-item>
            <el-form-item label="清洁费：" prop="cleaning">
                <el-input style="width: 30%;" v-model="addForm.cleaning" placeholder="请输入清洁费">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                </el-input>
            </el-form-item>
            <el-form-item label="房源时间设置：" required>
                <el-time-picker
                        is-range
                        v-model="check_time"
                        range-separator="至"
                        value-format="HH:mm:ss"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="最短入住天数：" prop="min_check_in_days">
                <el-input style="width: 30%;" v-model="addForm.min_check_in_days" placeholder="最短入住天数">
                    <template slot="append">天</template>
                </el-input>
            </el-form-item>
            <el-form-item label="接机服务：">
                <el-radio-group style="margin-top: 12px;" v-model="addForm.is_reception">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="addForm.is_reception===1" label="飞机场" prop="airport">
                <el-select v-model="addForm.airport" placeholder="请选择飞机场" filterable>
                    <el-option v-for="(item,index) in select.airport"
                               :key="index"
                               :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="addForm.is_reception===1" label="车型名称：" prop="car">
                <el-input style="width: 30%;" v-model="addForm.car" placeholder="车型名称"></el-input>
            </el-form-item>
            <el-form-item v-if="addForm.is_reception===1" label="可坐人数：" prop="car_num">
                <el-input style="width: 30%;" v-model="addForm.car_num" placeholder="可坐人数">
                    <template slot="append">人</template>
                </el-input>
            </el-form-item>
            <el-form-item v-if="addForm.is_reception===1" label="单程价格：" prop="car_price">
                <el-input style="width: 30%;" v-model="addForm.car_price" placeholder="单程价格">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                </el-input>
            </el-form-item>
            <el-form-item label="周边景点：" prop="scenery_id">
                <el-select v-model="addForm.scenery_id" filterable multiple>
                    <el-option v-for="(item,index) in sceneList" :key="index" :value="item.id"
                               :label="item.title">
                        <div class="select-item-content">
                            <img :src="`/api/v1/file/${item.cover}`" alt="">
                            <div>{{item.title}}</div>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="周边温泉：" prop="hot_id">
                <el-select v-model="addForm.hot_id" filterable multiple>
                    <el-option v-for="(item,index) in hotSpringList" :key="index" :value="item.id"
                               :label="item.title">
                        <div class="select-item-content">
                            <img :src="`/api/v1/file/${item.cover}`" alt="">
                            <div>{{item.title}}</div>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="周边美食：" prop="cate_id">
                <el-select v-model="addForm.cate_id" filterable multiple>
                    <el-option v-for="(item,index) in cateList" :key="index" :value="item.id"
                               :label="item.title">
                        <div class="select-item-content">
                            <img :src="`/api/v1/file/${item.cover}`" alt="">
                            <div>{{item.title}}</div>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否开启闪订功能：">
                <el-radio-group style="margin-top: 12px;" v-model="addForm.flash">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="">
                <el-button v-if="id" type="primary" @click="editHouse">编辑房源</el-button>
                <el-button v-else type="primary" @click="submitHouse">发布房源</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="地图选点" :visible.sync="showMap" :close-on-click-modal="false">
            <baidu-map class="map-content"
                       scroll-wheel-zoom
                       @ready="mapReady"
                       @click="handlerMapClick"
                       :center="getMapCenter"
                       :zoom="12">
                <bm-marker v-if="addForm.lon&&addForm.lat" :position="{lng: addForm.lon, lat: addForm.lat}"></bm-marker>
            </baidu-map>
            <div class="f-14 color-red mt-20" v-if="addForm.address">已选地址：<span class="fw-b">{{addForm.address}}</span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {formVerify, delToast} from '@/utlis/decorators'

    export default {
        name: "addHouse",
        data() {
            return {
                id: '',
                select: [],
                check_time: ['', ''],
                addForm: {
                    title: '',
                    cover: '',
                    image: [],
                    house_type_id: '',
                    room_type_id: '',
                    people: 1,
                    max_people: 1,
                    toilet: {
                        '独立卫生间': 0,
                        '公共卫生间': 0
                    },
                    bed_id: [],
                    facility_id: [],
                    area_id: '',
                    area_name: '',
                    address: '',
                    content: '',
                    check_in_rules: '',
                    day1: '',
                    day2: '',
                    ratio: '',
                    mark: '',
                    price: '',
                    discount7: '',
                    discount30: '',
                    deposit: '',
                    capitation: '',
                    cleaning: '',
                    check_in_time: '',
                    check_out_time: '',
                    min_check_in_days: '',
                    scenery_id: [],
                    hot_id: [],
                    cate_id: [],
                    is_reception: 2,
                    car: '',
                    car_num: '',
                    car_price: '',
                    airport: '',
                    flash: 2,
                    lon: '',
                    lat: '',
                    client: [0, 0, 0, 0]
                },
                houseRules: [[]],
                rules: {
                    title: [{required: true, message: '请输入标题', trigger: ['blur', 'change']}],
                    cover: [{required: true, message: '请上传封面', trigger: ['blur', 'change']}],
                    house_type_id: [{required: true, message: '请选择房源类型', trigger: ['blur', 'change']}],
                    room_type_id: [{required: true, message: '请选择房间类型', trigger: ['blur', 'change']}],
                    facility_id: [{required: true, message: '请选择配套设置', trigger: ['blur', 'change']}],
                    people: [{required: true, message: '请输入入住人数', trigger: ['blur', 'change']}],
                    max_people: [{required: true, message: '请输入最大入住人数', trigger: ['blur', 'change']}],
                    area_id: [{required: true, message: '请选择地区', trigger: ['blur', 'change']}],
                    address: [{required: true, message: '请输入详细地址', trigger: ['blur', 'change']}],
                    content: [{required: true, message: '请输入房源介绍', trigger: ['blur', 'change']}],
                    mark: [{required: true, message: '请选择退款规则', trigger: ['blur', 'change']}],
                    price: [{required: true, message: '请输入价格', trigger: ['blur', 'change']}],
                    discount7: [{required: true, message: '请输入7天折扣价', trigger: ['blur', 'change']}],
                    discount30: [{required: true, message: '请输入30天折扣价', trigger: ['blur', 'change']}],
                    deposit: [{required: true, message: '请输入押金', trigger: ['blur', 'change']}],
                    capitation: [{required: true, message: '请输入额外人员费用', trigger: ['blur', 'change']}],
                    cleaning: [{required: true, message: '请输入清洁费', trigger: ['blur', 'change']}],
                    min_check_in_days: [{required: true, message: '请输入最小入住天数', trigger: ['blur', 'change']}],
                    car: [{required: true, message: '请输入车型名称', trigger: ['blur', 'change']}],
                    car_num: [{required: true, message: '请输入可坐人数', trigger: ['blur', 'change']}],
                    car_price: [{required: true, message: '请输入单程价格', trigger: ['blur', 'change']}],
                    airport: [{required: true, message: '请选择机场', trigger: ['blur', 'change']}]
                },
                sceneList: [],
                hotSpringList: [],
                cateList: [],
                start: '',
                startIndex: '',
                end: '',
                endIdnex: '',
                showMap: false,
                geoc: ''
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.getLandlordAdd();
            this.getHouseRules();
            this.userScenery();
            this.userHotSpring();
            this.userCate();
        },
        computed: {
            ...mapState(['cityList']),
            getMapCenter() {
                if (this.addForm.lon && this.addForm.lat) {
                    return {lng: this.addForm.lon, lat: this.addForm.lat}
                }else if(this.addForm.area_name){
                    return this.addForm.area_name
                }
                return '东京'
            }
        },
        watch: {
            'addForm.area_id'(newVal) {
                if (newVal) {
                    this.addForm.area_name = this.cityList.find(it => it.id === newVal).name
                }
            },
            'addForm.mark'(newVal) {
                let obj = this.houseRules[0].find(it => it.id === newVal);
                if (obj) {
                    this.addForm.day1 = obj.day1;
                    this.addForm.day2 = obj.day2;
                    this.addForm.ratio = obj.ratio;
                }
            },
            check_time(newVal) {
                this.addForm.check_in_time = newVal[0];
                this.addForm.check_out_time = newVal[1];
            }
        },
        methods: {
            @delToast('是否删除该图片？')
            async delImg(index){
                this.addForm.image.splice(index, 1)
            },
            mapReady({BMap, map}) {
                this.geoc = new BMap.Geocoder();
            },
            handlerMapClick(e) {
                this.addForm.lat = e.point.lat;
                this.addForm.lon = e.point.lng;
                this.geoc.getLocation(e.point, (res) => {
                    this.addForm.address = res.address
                })
            },
            async getEditHouse() {
                let [e, data] = await this.$api.getEditHouseApi({house_id: this.id})
                this.addForm.title = data.result.house.title;
                this.addForm.cover = data.result.house.cover;
                this.addForm.image = data.result.house.image;
                this.addForm.house_type_id = data.result.house.house_type_id;
                this.addForm.room_type_id = data.result.house.room_type_id;
                this.addForm.people = data.result.house.people;
                this.addForm.max_people = data.result.house.max_people;
                this.addForm.address = data.result.house.address;
                this.addForm.content = data.result.house.content;
                this.addForm.area_id = data.result.house.area_id;
                this.addForm.check_in_rules = data.result.house.check_in_rules;
                this.addForm.mark = data.result.rules.mark;
                this.addForm.day1 = data.result.rules.day1;
                this.addForm.day2 = data.result.rules.day2;
                this.addForm.ratio = data.result.rules.ratio;
                this.addForm.price = data.result.house.price;
                this.addForm.discount7 = data.result.house.discount7;
                this.addForm.discount30 = data.result.house.discount30;
                this.addForm.deposit = data.result.house.deposit;
                this.addForm.capitation = data.result.house.capitation;
                this.addForm.cleaning = data.result.house.cleaning;
                this.addForm.check_in_time = data.result.house.check_in_time;
                this.addForm.check_out_time = data.result.house.check_out_time;
                this.check_time = [data.result.house.check_in_time, data.result.house.check_out_time]
                this.addForm.min_check_in_days = data.result.house.min_check_in_days;
                this.addForm.is_reception = data.result.house.is_reception;
                this.addForm.car = data.result.house.car;
                this.addForm.car_num = data.result.house.car_num;
                this.addForm.car_price = data.result.house.car_price;
                this.addForm.flash = data.result.house.flash;
                this.addForm.lat = data.result.house.lat;
                this.addForm.lon = data.result.house.lon;
                this.addForm.facility_id = data.result.facility;
                this.addForm.bed_id.forEach(it=>{
                    it.number = data.result.bed[it.id] || 0
                })
            },
            async getLandlordAdd() {
                let [e, data] = await this.$api.getLandlordAddApi();
                this.select = data.result;
                this.addForm.bed_id = data.result.bed.reduce((ary, item) => {
                    ary.push({
                        id: item.id,
                        name: item.name,
                        number: 0
                    })
                    return ary
                }, [])
                if (this.id) {
                    this.getEditHouse();
                }
            },
            async getHouseRules() {
                let [e, data] = await this.$api.getHouseRulesApi();
                this.houseRules = data.result;
            },
            async userScenery() {
                let [e, data] = await this.$api.userSceneryApi();
                this.sceneList = data.result;
            },
            async userHotSpring() {
                let [e, data] = await this.$api.userHotSpringApi();
                this.hotSpringList = data.result;
            },
            async userCate() {
                let [e, data] = await this.$api.userCateApi();
                this.cateList = data.result;
            },
            async uploadCover(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.cover = data.result;
                }
            },
            async uploadImage(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.image.push(data.result);
                }
            },
            handlerStart(item, index) {
                this.start = item
                this.startIndex = index
            },
            handlerEnd(item, index) {
                if (this.startIndex === this.endIdnex) return;
                this.addForm.image.splice(this.startIndex, 1, this.end);
                this.addForm.image.splice(this.endIdnex, 1, this.start);
            },
            handlerEnter(item, index) {
                this.end = item
                this.endIdnex = index
            },
            @formVerify()
            async submitHouse() {
                let [e, data] = await this.$api.addLandlordHouseApi(this.addForm);
                if (data.code === 200) {
                    this.$message.success('发布成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            },
            @formVerify()
            async editHouse(){
                let [e, data] = await this.$api.editHouseApi({house_id: this.id, ...this.addForm})
                if (data.code === 200) {
                    this.$message.success('保存成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .input-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-flow: wrap;
    }

    .select-item-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        img {
            width: 30px;
            height: 30px;
            object-fit: cover;
        }
    }

    .img-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .img-content-item {
            width: 150px;
            height: 150px;
            object-fit: cover;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }

    .drag-move {
        transition: 0.3s;
    }

    .map-content {
        width: 100%;
        height: 500px;
    }
</style>
